import { FormControl, TextField, Typography, styled, SxProps, Theme } from "@mui/material";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: "16px",
  "& .MuiTypography-root": {
    fontSize: "14px",
    color: theme.palette.text.secondary,
    marginTop: "8px",
    textAlign: "right",
  },
}));

interface QuestionTextareaProps {
  questionNumber: number;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minRows?: number;
  maxRows?: number;
  maxWords?: number;
  sx?: SxProps<Theme>;
}

function QuestionTextarea({
  questionNumber,
  value = "",
  onChange,
  placeholder = "Enter your answer here...",
  minRows = 4,
  maxRows = 8,
  maxWords = 500,
  sx,
}: QuestionTextareaProps) {
  const wordCount = value.trim().split(/\s+/).filter(Boolean).length;

  return (
    <StyledFormControl fullWidth sx={sx}>
      <TextField
        multiline
        minRows={minRows}
        maxRows={maxRows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        variant="outlined"
        inputProps={{
          "aria-label": `Question ${questionNumber} textarea`,
        }}
      />
      <Typography>
        {wordCount} / {maxWords} words
      </Typography>
    </StyledFormControl>
  );
}

export default QuestionTextarea;
